import { toast } from 'sonner';

import { useAppDispatch } from '../../../../features';
import { closeModal } from '../../../../features/slice/event/event-slice';
import { useCreateTypeMutation } from '../../../../features/slice/products/type/type-api-slice';
import { CreateTypeSchemaType } from './type.schema';

export const useCreateType = () => {
    const dispatch = useAppDispatch();
    const [createType, { isLoading, isSuccess }] = useCreateTypeMutation();

    const onSubmit = async (value: CreateTypeSchemaType) => {
        try {
            await createType({
                name: value.name,
            }).unwrap();

            toast.success('Type Created Succesfully!');
            dispatch(closeModal());
        } catch (error) {
            toast.error((error as any).data.message);
        }
    };

    return {
        onSubmit,

        isLoading,
        isSuccess,
    };
};
